<app-header></app-header>

<div class="dashboard-container container mt-4" style="background: #c6c3f6; border-radius: 8px; padding: 20px; min-height: 700px;">
    <h2>Call Center Dashboard</h2>

    <!-- Bootstrap Table -->
    <div class="table-responsive rounded">
        <table class="table table-bordered table-striped table-hover rounded">
            <thead class="thead-dark">
                <tr>
                    <th>Req. No.</th>
                    <th>Emp Code</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Age</th>
                    <th>Package Name</th>
                    <!-- <th>Created Date</th> -->
                    <th>Slot</th>
                    <!-- <th>Base Location</th> -->
                    <th>Center</th>
                    <th>Remark</th>
                    <!-- <th>Existing Ailment</th> -->
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let candidate of candidates">
                    <td>{{ candidate.requestNumber }}</td>
                    <td>{{ candidate.empCode }}</td>
                    <td>{{ candidate.name }}</td>
                    <td>{{ candidate.email }}</td>
                    <td>{{ candidate.phoneNumber }}</td>
                    <td>{{ candidate.age }}</td>
                    <td>{{ candidate.testPackageName }}</td>
                    <!-- <td>{{ candidate.createdDate?.slice(0,10) }}</td> -->
                    <td>{{ candidate.slot }} </td>
                    <!-- <td>{{ candidate.baseLocation }}</td> -->
                    <td>{{ candidate.center }}</td>
                    <td>
                        <span [tooltip]="candidate.remark" placement="top">
                          {{ candidate.remark | truncate: 20 }} <!-- Truncate the remark for display -->
                        </span>
                      </td>
                    <!-- <td>{{ candidate.existingAilment }}</td> -->
                    <td>
                        <button class="btn btn-sm" style="width: 100px; background: #6C63FF;" (click)="openStatusModal(candidate, statusModalTemplate)">
                            {{ candidate.status }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Page Controls Container -->
    <div class="d-flex justify-content-between align-items-center flex-wrap">
        <!-- Page Size Selection -->
        <div class="d-flex align-items-center">
            <label for="pageSize" class="me-2">Rows per page:</label>
            <select id="pageSize" [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="form-select w-auto">
                <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
            </select>
        </div>

        <!-- Pagination Info -->
        <div class="pagination-info text-center flex-grow-1">
            Showing data {{ (currentPage - 1) * pageSize + 1 }} -
            {{ (currentPage * pageSize) > totalItems ? totalItems : (currentPage * pageSize) }} of {{ totalItems }}
            Records
        </div>

        <!-- Bootstrap Pagination -->
        <nav aria-label="Page navigation" class="mx-auto mt-1">
            <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPage === 1">
                    <a class="page-link" (click)="onPageChange(currentPage - 1)" aria-label="Previous">
                        <i class="bi bi-chevron-left"></i>
                    </a>
                </li>
                <li class="page-item" *ngFor="let page of getPages()" [class.active]="page === currentPage">
                    <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage * pageSize >= totalItems">
                    <a class="page-link" (click)="onPageChange(currentPage + 1)" aria-label="Next">
                        <i class="bi bi-chevron-right"></i>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</div>

<!-- Status Update Modal Template -->
<ng-template #statusModalTemplate>
    <div class="modal-header" style="background: #6c63FF">
        <h5 class="modal-title">Update Status</h5>
        <button type="button" class="btn-close" (click)="modalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
        <form>
            <div class="mb-3">
                <label for="statusDropdown" class="form-label">Select Status</label>
                <select class="form-select" id="statusDropdown" [(ngModel)]="selectedStatus" name="status" (change)="onStatusChange()">
                    <option value="Pending">Pending</option>
                    <option value="Reschedule">Reschedule</option>
                    <option value="Cancel">Cancel</option>
                    <option value="Confirmed">Confirmed</option>
                </select>
            </div>
            <div class="mb-3" *ngIf="selectedStatus === 'Reschedule'">
                <label for="newSlotInput" class="form-label">New Slot</label>
                <input 
                    type="datetime-local" 
                    class="form-control" 
                    id="newSlotInput" 
                    [(ngModel)]="newSlot" 
                    name="newSlot"
                    [min]="getCurrentDateTime()" 
                >
            </div>
            <div class="mb-3">
                <label for="remarkInput" class="form-label">Remark</label>
                <textarea class="form-control" id="remarkInput" [(ngModel)]="remark" name="remark" rows="3"></textarea>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Close</button>
        <button type="button" class="btn btn-primary" (click)="updateStatus()">Update</button>
    </div>
</ng-template>


<!-- Success Modal Template -->
<ng-template #successTemplate>
    <div class="modal-header">
      <h5 class="modal-title">{{ headerMessage }}</h5>
      <button type="button" class="btn-close" (click)="modalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <p>{{ bodyMessage }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modalRef.hide()">Close</button>
    </div>
  </ng-template>
  
  <!-- Failure Modal Template -->
  <ng-template #failureTemplate>
    <div class="modal-header">
      <h5 class="modal-title">{{ headerMessage }}</h5>
      <button type="button" class="btn-close" (click)="modalRef.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <p>{{ bodyMessage }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modalRef.hide()">Close</button>
    </div>
  </ng-template>